import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_backtop = _resolveComponent("el-backtop");

  const _component_vab_theme_drawer = _resolveComponent("vab-theme-drawer");

  const _component_vab_theme_setting = _resolveComponent("vab-theme-setting");

  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["vue-admin-beautiful-wrapper", {
      mobile: _ctx.mobile
    }])
  }, [(_openBlock(), _createBlock(_resolveDynamicComponent('vab-layout-' + _ctx.theme.layout), {
    collapse: _ctx.collapse,
    device: _ctx.device,
    "fixed-header": _ctx.theme.fixedHeader,
    "show-tabs": _ctx.theme.showTabs
  }, null, 8
  /* PROPS */
  , ["collapse", "device", "fixed-header", "show-tabs"])), _createVNode(_component_el_backtop, {
    target: "#app"
  }), _createCommentVNode("  主题组件放到layouts下防止主题切换，导致主题组件重新加载 "), _createVNode(_component_vab_theme_drawer), _createVNode(_component_vab_theme_setting)], 2
  /* CLASS */
  );
}